import React from 'react';
import { Link } from 'react-router-dom';
import './AuthLayout.css';

const AuthLayout = ({ children }) => {
  return (
    <div className="auth-layout">
      <div className="auth-container">
        <div className="auth-content">
          {children}
        </div>
        
        <div className="auth-footer">
          <p>
            <Link to="/" className="auth-link">← Back to Home</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
